import { useQuery } from '@tanstack/react-query';
import { useAccountApi } from '../../hooks/use-settings-api';

export const QK_TWO_FACTOR_RECOVERY_CODES = ['two-factor-recovery-codes'] as const;

export function useRecoveryCodes(enabled: boolean) {
  const { accountApi } = useAccountApi();

  return useQuery({
    queryKey: QK_TWO_FACTOR_RECOVERY_CODES,
    queryFn: () => accountApi.recoveryCodes(),
    enabled,
    // These are security credentials, not app data - the cache must not outlive the component
    // that's actively showing them (e.g. across a logout/login in the same tab), and a 423 from
    // an expired password confirmation is never transient, so retrying it is pointless.
    gcTime: 0,
    retry: false,
  });
}
